module.exports = __webpack_public_path__ + "img/10.9c19b21a.jpg";